import PriceChange from '@/components/PriceChange'
import type { CoinOverall } from '@/types/coin'

import { useCoinsTableStore } from '../../context'

interface Props {
  coin: Pick<CoinOverall, 'usd_price_change_24h' | 'slug'>
}

export default function PriceChangeColumn({ coin }: Props) {
  const liveUsdPriceChange24h = useCoinsTableStore(
    state => state.liveCoinsMarket[coin.slug]?.usd_price_change_24h,
  )
  return <PriceChange value={liveUsdPriceChange24h ?? coin.usd_price_change_24h} />
}
